export const faqData = [
    {
        cardText: "If you don’t avail any services for your AC after our Service Provider send a technician at your doorstep then you only have to pay the visiting charge which is BDT 100.",
        cardHeader: "Do I have to pay any charge if I don’t take any service? "
    },
    {
        cardText: "Of course not! After service completion you will receive a text on your mobile from Sheba.xyz then you have to pay through Online or Cash on Delivery.",
        cardHeader: "Do I have to pay advance money before availing your service?"
    },
    
    {
        cardText: "Definitely not! As long as you want to avail this service for your AC then you can order for your office Air Conditioners too",
        cardHeader: "Is this only for household AC?"
    },
    {
        cardText: "Our professional Service Providers have expert and skilled AC technicians. If they occur any damages to your AC during repairing you will get proper compensation after proper investigation. However, your complaint for any pre-damaged problems will not be considered.",
        cardHeader: "What if they damage my AC?"
    },
    {
        cardText: "No. We do not manufacture AC parts by ourselves. So, the warranty differs as per manufacturer. However, we can give you 7 days free service warranty.",
        cardHeader: "Do you give Materials/Parts warranty?"
    },
    
    
    {
        cardText: "Certainly. You can buy necessary and required materials/parts by yourself. But any operational dysfunctionality won’t be held responsible by our Service Providers and Sheba.xyz itself.",
        cardHeader: "Can I buy AC materials/parts by myself and ask your technician to use them?"
    }
]